import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Broadcast {
  private readonly _eventSubject = new ReplaySubject<any>(1);

  event$ = this._eventSubject.asObservable();

  broadcastEvent(data: any) {

    this._eventSubject.next(data);
  }

  getBroadcast() {
    return this._eventSubject.asObservable();
  }
}
